import sh from "./sh";
import engagementTracker from "bundles/Recruiter/engagement/engagementTracker";

const SESSION_KEY = "sq_feature_session_id";

// crypto.randomUUID is missing on older Safari and on non-HTTPS origins.
const randomId = () =>
  typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

let fallbackSessionId = null;

// sessionStorage throws when site storage is blocked, so fall back to an in-memory id.
const getSessionId = () => {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = randomId();
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    fallbackSessionId = fallbackSessionId || randomId();
    return fallbackSessionId;
  }
};

// Tracking failures are silent — never block the user, including synchronous errors.
const trackEvent = (feature, action, properties = {}) => {
  try {
    // Engagement periods tag each event with the period it happened in; read inside the try so
    // a tracker hiccup can never surface to the user either.
    const periodId = engagementTracker.currentPeriodId();

    sh.post(
      "/feature_events",
      {
        feature_event: {
          feature,
          action,
          session_id: getSessionId(),
          properties: periodId ? { ...properties, period_id: periodId } : properties,
        },
      },
      // Concurrent events must not cancel each other (sh cancels by URL by default).
      { cancelKey: `feature_events:${randomId()}` }
    ).catch(() => {});
  } catch {
    // ignore
  }
};

// Read-only: the id of anonymous events recorded in this tab, if any (sent at login/signup
// so the server can attach them to the account).
export const getStoredFeatureSessionId = () => {
  try {
    return sessionStorage.getItem(SESSION_KEY) || fallbackSessionId;
  } catch {
    return fallbackSessionId;
  }
};

export default trackEvent;
